import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { generateFCMToken } from '../firbase';

function RequestNotificationPermission() {
    const [dialogStatus,setDialogStatus] = useState(false);
    const handleNo = () =>{
        setDialogStatus(false);
    }
    const handleYes = async () =>{
        try{
            const permission = await Notification.requestPermission();
            if(permission == "granted"){
                generateFCMToken();
                setDialogStatus(false);
            }
        } catch(error){
            console.log(error);
        }
    }
    useEffect(()=>{
        try{
            //console.log(Notification.permission)
            if(Notification.permission === "default"){
                setDialogStatus(true);
            }
            if(Notification.permission === "granted"){
                generateFCMToken()
            }
        } catch(error){
            console.log(error);
        }
    },[])
    return (
        <Dialog
            open={dialogStatus}
            keepMounted
           
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle>Would You like to receive notifications</DialogTitle>
            <DialogContent>
                <p>Get Notified about your visit</p>
            </DialogContent>
            <DialogActions>
                <button className='btn btn-outline-default' onClick={handleNo}  >No</button>
                <button className='btn btn-primary' onClick={handleYes} >Yes, Allow</button>
                
            </DialogActions>
        </Dialog>
    )
}

export default RequestNotificationPermission